import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/CriteriQualitativi';
import { selectors, DEFAULT_STATE } from '../reducers/CriteriQualitativi';
import api from '../apis/CriteriQualitativi';

const sagas = helper.createSagas('criteriQualitativi', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];